<template>
  <div class="language-switcher">
    <a href="javascript:void(0);" @click="setLanguage('en-US')">English</a> |
    <a href="javascript:void(0);" @click="setLanguage('zh-CN')">中文</a>
  </div>
</template>

<script>
import i18n from '@/i18n'
import cookie from '@/utils/cookie'

export default {
  data () {
    return {
      locale: i18n.locale
    }
  },
  methods: {
    setLanguage (lang) {
      i18n.locale = lang
      this.locale = lang
      const domain = window.location.host.split(':')[0].split('.').splice(1).join('.')
      cookie.setCookie('CometLanguage', lang, '7', '.' + domain)
    }
  }
}
</script>

<style lang="scss" scoped>
.language-switcher {
  margin-left: 12px;
  display: inline-block;

  a {
    color: #f8b62b;
  }
}
</style>
